/**
 * Seam between a notification-preferences API and the local persisted store,
 * the same arrangement as `features/loyalty/config.ts`.
 *
 * - false (the only working value today): the switches live in
 *   `useNotificationPreferences`, in this browser only, and nothing is sent.
 * - true: the store would be read from and written to the endpoint below.
 *
 * WHY IT IS OFF: `menu_core_be` has neither half of this. It has no endpoint
 * for a user's own preferences (there is no `/me` of any kind), and nothing it
 * would send mail about: bookings and reviews are front-end stubs themselves
 * (`features/website-builder`, `features/feedback`). The backend needs both a
 * place to keep the two flags per user and the mails they switch.
 */
export const NOTIFICATIONS_USE_API = false

/** Backend path, relative to `/restaurants/{restaurantId}`. */
export const NOTIFICATIONS_ENDPOINT = '/users/notification-preferences'

/**
 * Seam for "sign out everywhere" in Settings > Account.
 *
 * - false (the only working value today): the button signs out this browser
 *   only. Every other device stays signed in, whatever the copy says.
 * - true: the endpoint below is called first, then this browser signs out.
 *
 * WHY IT IS OFF: ending another device's session takes the Firebase Admin
 * SDK, which only the backend holds, and `menu_core_be` has no such route.
 * It needs an authenticated POST (JwtGuard and `@Sub()`, no restaurant in
 * the path, since a session is the account's) that calls
 * `auth.revokeRefreshTokens(sub)` in the caller's tenant. A revoked device
 * keeps its ID token until it expires, up to an hour, unless the guard also
 * verifies tokens with `checkRevoked`.
 */
export const SIGN_OUT_EVERYWHERE_USE_API = false

/** Backend path, at the root: not under `/restaurants/{restaurantId}`. */
export const SIGN_OUT_EVERYWHERE_ENDPOINT = '/users/me/sessions/revoke'
